import _Icon from "choerodon-ui/lib/icon";
import React from "react"; // import { Icon } from "@hzero-front-ui/hzero-ui/lib";
// import 'choerodon-ui/dist/choerodon-ui.css';

import "choerodon-ui/lib/icon/style";
import { IconDisplayWrapper, IconSectionTitle, IconSectionWrapper, IconTitle, IconWrapper } from "./index.style";
var menuIcons = ["interface-management", "business-settings", "credit-platform", "governance-platform", "data-platform", "store-management", "cloud-management", "enterprise-certification", "workflow", "cloud-service", "commodity-management", "partner", "cloud-partner", "notice", "expert-library", "purchase", "offer", "sale", "import-meau", "quality-business", "finance", "sourcing"];
var btnIcon = ["add", "get_app",
// "export",
"select", "open_in_new", "flash_on", "recover", "sync", "relation", "check", "download", "upload", "refresh", "double-down", "double-up", "publish", "read", "revocation", "link2", "schedule", "printer", "repeat", "history", "settings", "delete", "save"];
var tableIcons = ["unfold_more", "filter", "mode_edit", "publish2", "delete", "link2", "add_box", "indeterminate_check_box", "more_vert"];
var otherIcon = ["search", "close", "arrow_back", "arrow_drop_down", "arrow_drop_up", "expand_more", "expand_less", "visibility", "visibility_off", "calendar", "layers", "navigate_next", "double-right", "navigate_before", "double-left" // "word",
// "excel",
// "ppt",
// "unknown",
];

export default function IconDisplay() {
  return /*#__PURE__*/React.createElement(IconDisplayWrapper, {
    className: "icon-container"
  }, /*#__PURE__*/React.createElement(IconSectionTitle, null, "\u83DC\u5355Icon"), /*#__PURE__*/React.createElement(IconSectionWrapper, null, menuIcons.map(function (v) {
    return /*#__PURE__*/React.createElement(IconWrapper, {
      key: v
    }, /*#__PURE__*/React.createElement(_Icon, {
      type: v,
      style: {
        fontSize: 24
      }
    }), /*#__PURE__*/React.createElement(IconTitle, null, v));
  })), /*#__PURE__*/React.createElement(IconSectionTitle, null, "\u6309\u94AEIcon"), /*#__PURE__*/React.createElement(IconSectionWrapper, null, btnIcon.map(function (v) {
    return /*#__PURE__*/React.createElement(IconWrapper, {
      key: v
    }, /*#__PURE__*/React.createElement(_Icon, {
      type: v,
      style: {
        fontSize: 24
      }
    }), /*#__PURE__*/React.createElement(IconTitle, null, v));
  })), /*#__PURE__*/React.createElement(IconSectionTitle, null, "\u8868\u683C\u5185Icon"), /*#__PURE__*/React.createElement(IconSectionWrapper, null, tableIcons.map(function (v) {
    return /*#__PURE__*/React.createElement(IconWrapper, {
      key: v
    }, /*#__PURE__*/React.createElement(_Icon, {
      type: v,
      style: {
        fontSize: 24
      }
    }), /*#__PURE__*/React.createElement(IconTitle, null, v));
  })), /*#__PURE__*/React.createElement(IconSectionTitle, null, "\u5176\u5B83Icon"), /*#__PURE__*/React.createElement(IconSectionWrapper, null, otherIcon.map(function (v) {
    return /*#__PURE__*/React.createElement(IconWrapper, {
      key: v
    }, /*#__PURE__*/React.createElement(_Icon, {
      type: v,
      style: {
        fontSize: 24
      }
    }), /*#__PURE__*/React.createElement(IconTitle, null, v));
  })));
}